export const DEFAULT_INSTRUCTIVE_MODE = 'normal';

export const INSTRUCTIVE_STORAGE_REVISIONS = Object.freeze({
  show_offers: Object.freeze({
    normal: Object.freeze({
      revision: 1,
      legacyRevision: 1,
    }),
    evento: Object.freeze({
      revision: 1,
    }),
  }),
});

const getRevisionSettings = (
  instructive,
  mode = DEFAULT_INSTRUCTIVE_MODE,
  revisions = INSTRUCTIVE_STORAGE_REVISIONS,
) => {
  return revisions[instructive]?.[mode || DEFAULT_INSTRUCTIVE_MODE];
};

export const getInstructiveStorageKey = (
  instructive,
  mode = DEFAULT_INSTRUCTIVE_MODE,
  revisions = INSTRUCTIVE_STORAGE_REVISIONS,
) => {
  const settings = getRevisionSettings(instructive, mode, revisions);
  if (!settings) return instructive;

  return `${instructive}:${mode || DEFAULT_INSTRUCTIVE_MODE}:v${settings.revision}`;
};

export const getLegacyInstructiveStorageKey = (
  instructive,
  mode = DEFAULT_INSTRUCTIVE_MODE,
  revisions = INSTRUCTIVE_STORAGE_REVISIONS,
) => {
  const settings = getRevisionSettings(instructive, mode, revisions);
  if (!settings || settings.legacyRevision !== settings.revision) return null;

  return instructive;
};

const isStoredAsSeen = (value) => {
  if (value === null) return false;

  try {
    return !JSON.parse(value);
  } catch (_) {
    return false;
  }
};

export const hasSeenInstructive = (
  storage,
  instructive,
  mode = DEFAULT_INSTRUCTIVE_MODE,
  revisions = INSTRUCTIVE_STORAGE_REVISIONS,
) => {
  const storageKey = getInstructiveStorageKey(instructive, mode, revisions);
  const storedValue = storage.getItem(storageKey);
  if (storedValue !== null) return isStoredAsSeen(storedValue);

  const legacyStorageKey = getLegacyInstructiveStorageKey(instructive, mode, revisions);
  if (!legacyStorageKey || legacyStorageKey === storageKey) return false;

  return isStoredAsSeen(storage.getItem(legacyStorageKey));
};

export const markInstructiveSeen = (
  storage,
  instructive,
  mode = DEFAULT_INSTRUCTIVE_MODE,
  revisions = INSTRUCTIVE_STORAGE_REVISIONS,
) => {
  const storageKey = getInstructiveStorageKey(instructive, mode, revisions);
  storage.setItem(storageKey, JSON.stringify(false));

  const legacyStorageKey = getLegacyInstructiveStorageKey(instructive, mode, revisions);
  if (legacyStorageKey && legacyStorageKey !== storageKey) {
    storage.setItem(legacyStorageKey, JSON.stringify(false));
  }
};
